import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "@/lib/auth";
import { PageErrorBoundary } from "@/components/PageErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <PageErrorBoundary title="Uygulama yüklenirken bir sorun oluştu">
          <App />
        </PageErrorBoundary>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// -------- PWA service worker registration --------
if ("serviceWorker" in navigator) {
  let hasReloaded = false;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Hourly background update checks
        setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
        // When a new SW is found, auto-apply it as soon as it's installed
        reg.addEventListener("updatefound", () => {
          const incoming = reg.installing;
          if (!incoming) return;
          incoming.addEventListener("statechange", () => {
            if (incoming.state === "installed" && navigator.serviceWorker.controller) {
              // A new version is waiting; tell it to activate immediately
              try { incoming.postMessage({ type: "SKIP_WAITING" }); } catch {}
            }
          });
        });
      })
      .catch(() => {});
    // When the controlling SW switches (new version took over), reload once so the fresh app shell loads
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (hasReloaded) return;
      hasReloaded = true;
      window.location.reload();
    });
  });
}
